import { render, staticRenderFns } from "./incl-pimCampaigns.vue?vue&type=template&id=0bb95683&scoped=true"
import script from "./incl-pimCampaigns.vue?vue&type=script&lang=js"
export * from "./incl-pimCampaigns.vue?vue&type=script&lang=js"
import style0 from "./incl-pimCampaigns.vue?vue&type=style&index=0&id=0bb95683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb95683",
  null
  
)

export default component.exports